import React from "react";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Button,
  FormFeedback,
  Input
} from "reactstrap";
import ReactDragList from "react-drag-list";
import Select from "react-select";
import { makeStyles } from '@material-ui/core/styles';
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import { deepClone } from "../../../../../helpers/objectHelper";
import "./Options.css";
import SelectAddItem from "../../../../components/selects/SelectAddItem";
import { attendeeActions } from "../../../../../store/actions/attendee/attendee.action";
import Popover from '@material-ui/core/Popover';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import JirangoCheckbox2 from "../../../../../components/UI/Checkbox/JirangoCheckbox2";
import Media from 'react-media';
import { cmsActions } from "../../../../../store/actions/cms/cms.action";

const useStyles = makeStyles({});

const defaultOption = {
  isChanged: false,
  isSelected: false,
  isDeleted: false,
  labels: [],
  optionId: -1,
  sortOrder: -1,
  className: "default-checkbox"
};
class Options extends React.PureComponent {
  select = option => {
    const { dispatch } = this.props;
    dispatch(formActions.selectOption(option));
  };
  removeOption = (optionId, e) => {
    e.stopPropagation();
    const element = deepClone(this.props.parent);
    element.props.options.map(o => {
      if (o.optionId == optionId) {
        o.isDeleted = !(o.isDeleted || false);
      }
    });
    this.props.dispatch(formActions.updateFormElement(element));
  };
  addOption = (value = null) => {
    const element = deepClone(this.props.parent);
    const { form } = this.props;
    const { eventCodes } = this.props.language;
    const option = deepClone(defaultOption);
    if (eventCodes) {
      for (let j = 0; j < eventCodes.length; j++) {
        if (!value) {
          option.labels.push({
            text: "",
            languageCode: eventCodes[j].code,
            isValid: false
          });
        } else {
          option.labels.push({
            text:
              value +
              (eventCodes[j].code == form.languageCode
                ? ""
                : "(" + eventCodes[j].code + ")"),
            languageCode: eventCodes[j].code,
            isValid: false
          });
        }
      }
    }
    option.sortOrder =
      element.props.options.length > 0 ? element.props.options.length + 1 : 1;
    option.optionId = option.sortOrder * -1;
    element.props.options.push(option);
    this.props.dispatch(formActions.updateFormElement(element));
  };
  addListOptions = value => {
    const options = value.split("\n");
    const { eventCodes } = this.props.language;
    const { form } = this.props;
    const element = deepClone(this.props.parent);
    options.map(o => {
      if (o !== "") {
        if (eventCodes) {
          let sortOrder =
            element.props.options.length > 0
              ? element.props.options.length + 1
              : 1;

          let option = deepClone(defaultOption);
          for (let j = 0; j < eventCodes.length; j++) {
            option.labels.push({
              text:
                o +
                (eventCodes[j] == form.languageCode
                  ? ""
                  : "(" + eventCodes[j] + ")"),
              languageCode: eventCodes[j],
              isValid: false
            });
          }
          option.optionId = sortOrder * -1;
          option.sortOrder = sortOrder;
          element.props.options.push(option);
        }
      }
    });
    this.props.dispatch(formActions.updateFormElement(element));
  };
  handleChange = (value, optionId) => {
    const { parent, attendee, dispatch } = this.props;
    let isSelected = false;
    if (attendee && attendee.orders && attendee.orders.length > 0) {
      let order = deepClone(attendee.orders[attendee.activePersonNo]);

      if (!order.answer) {
        order.answer = [];
      }
      let answer = order.answer.find(a => a.questionId == parent.id);
      if (!answer) {
        answer = {
          answerId: 0,
          interactionKey: null,
          orderId: 0,
          questionId: parent.id,
          answerRow: []
        };
        order.answer.push(answer);
      }
      if (!answer.answerRow) {
        answer.answerRow = [];
      }
      if (value === true && parent.props.requiredMax === 1) {
        answer.answerRow.map(ar => (ar.deleted = true));
      }
      let row = answer.answerRow.find(ar => ar.questionOptionId == optionId);
      if (row) {
        row.deleted = !value;
      } else {
        answer.answerRow.push({
          answerId: answer.answerId,
          answerRowId: 0,
          questionOptionId: optionId,
          text: null,
          deleted: false
        });
      }
      answer.answerRow = answer.answerRow.filter(ar => {
        return !ar.deleted;
      });
      console.log("option", order.orderRow, order, attendee.activePersonNo);
      dispatch(attendeeActions.updateOrder(order, attendee.activePersonNo));
    }
    clearTimeout(this.validateTimeout);
    this.validateTimeout = setTimeout(this.props.validateOptions, 200);
  };
  labelOnChange = (val, optionId, languageCode = 'swe') => {
    const { parent } = this.props;
    let element = deepClone(parent);
    element.props.options.map(o => {
      if (o.optionId == optionId) {
        o.isChanged = true;
        o.labels.map(ol => {
          if (ol.languageCode == languageCode) {
            ol.text = val;
          }
        });
      }
    });
    this.props.dispatch(formActions.updateFormElement(element));
  };

  handleOrderChange = (event, dataSource) => {
    const element = deepClone(this.props.parent);
    const sortedOptions = dataSource.map((ds, i) => {
      let el = Object.assign({}, ds);
      el.sortOrder = i + 1;
      el.isChanged = true;
      return el;
    });
    element.props.options = sortedOptions;
    this.props.dispatch(formActions.updateFormElement(element));
  };
  isParentSelected = () => {
    const { parent, selectedElement } = this.props;
    return (
      selectedElement &&
      selectedElement.contentId &&
      (selectedElement.contentId === parent.contentId ? true : false)
    );
  };
  sortOptions = () => {
    const { form, parent } = this.props;
    if (parent.props.options.length === 0) return [];
    let options = Array.from(parent.props.options);
    if (parent.data.sortType === "ALPHA") {
      options.sort(function (a, b) {
        let textA = "";
        let textB = "";
        if (a.labels && a.labels.length > 0) {
          let labelA = a.labels.find(l => {
            return l.languageCode === form.languageCode;
          });
          if (labelA) {
            textA = labelA.text.toUpperCase();
          }
        }
        if (b.labels && b.labels.length > 0) {
          let labelB = b.labels.find(l => {
            return l.languageCode === form.languageCode;
          });
          if (labelB) {
            textB = labelB.text.toUpperCase();
          }
        }
        if (textA < textB) return -1;
        else if (textA > textB) return 1;
        else return 0;
      });
    } else {
      options.sort((a, b) => {
        return a.sortOrder - b.sortOrder;
      });
    }
    return options;
  };

  getIsSelected = optionId => {
    const { parent, attendee } = this.props;
    let isSelected = false;
    if (attendee && attendee.orders && attendee.orders.length > 0) {
      let order = attendee.orders[attendee.activePersonNo];
      if (order.answer) {
        let answer = order.answer.find(a => a.questionId == parent.id);
        if (answer && answer.answerRow && answer.answerRow.length > 0) {
          let row = answer.answerRow.find(
            ar => ar.questionOptionId == optionId
          );
          if (row && !row.deleted) {
            isSelected = true;
          }
        }
      }
    }
    return isSelected;
  };
  render() {
    const { form, parent, template, selectedElement, cms, previewDevice } = this.props;
    let options = this.sortOptions();
    const parentSelected = this.isParentSelected();
    if (parent === undefined) return null;
    return (
      <div
        style={{
          paddingLeft:
            parent.data.displayType === "SELECT"
              ? "0px"
              : "-13px" 
        }}
      >
        {options !== undefined ? (
          <React.Fragment>
            {parent.data.displayType === "CHECKBOX" ? (
              <React.Fragment>
                <FormControl component="fieldset" >
                  <Media
                    queries={{
                      small: "(max-width: 599px)",
                      medium: "(min-width: 600px) and (max-width: 1199px)",
                      large: "(min-width: 1200px)"
                    }}
                  >
                    {matches => (
                      <FormGroup style={{
                        marginBottom: '0px', marginTop: parent.data.checkboxLabelPlacement === 'top' && !parent.data.hideCheckboxLabels ? (parent.data.displayCheckboxRowAsHeader &&
                          !matches.small &&
                          template.previewDevice !== 'smartphone' ? '-33px' : '0px') : '-10px',
                        marginLeft: parent.data.checkboxLabelPlacement !== 'start' ? '-13px' : 'initial',

                      }}>
                        <ReactDragList
                          animation={10}
                          dataSource={options}
                          rowKey={"optionId"}
                          className="simple-drag"
                          rowClassName="simple-drag-row"
                          style={parent.data.inline === true && !matches.small && template.previewDevice !== 'smartphone'
                            ? { display: "inline-flex" }
                            : { width: "100%" }
                          }
                          handles={false}
                          disabled={!form.editMode}
                          onUpdate={(event, dataSource) =>
                            this.handleOrderChange(event, dataSource)
                          }

                          row={(o, index) => {
                            return (
                              <Row style={{ margin: '0px' }}>
                                <Col style={{ padding: '0px' }}>
                                  <div
                                    style={{
                                      border:
                                        parentSelected && form.selectedOption === o
                                          ? "1px solid rgba(85, 147, 220, 0.58)"
                                          : "none",
                                      maxWidth: "100%",
                                      /*     maxHeight: '42px', */
                                      textDecorationLine: o.isDeleted
                                        ? "line-through"
                                        : undefined,
                                      color: o.isDeleted ? "red" : undefined
                                    }}
                                    key={index}
                                    onClick={() => this.select(o)}
                                  >
                                    <JirangoCheckbox2
                                      editable={cms.editMode}
                                      labelName={
                                        o.labels &&
                                        o.labels.length > 0 &&
                                        o.labels.find(l => {
                                          return (l.languageCode.code || l.languageCode ) === form.languageCode;
                                        }).text
                                      }
                                      textStyle={{
                                        ...template.template.content.text,
                                        textDecorationLine: o.isDeleted
                                          ? "line-through"
                                          : 'initial',
                                        color: cms.editMode && o.isDeleted
                                          ? "red"
                                          : template.template.content.text.color
                                      }}
                                      previewDevice={template.previewDevice}
                                      optionSpacing={parent.data.optionSpacing}
                                      inline={parent.data.inline}
                                      boxStyle={{
                                        ...template.template.content.button
                                      }}
                                      checkboxIsDisabled={parent.data.readOnly || cms.editMode || (!cms.editMode && this.props.isChangeLocked())}
                                      labelPlacement={parent.data.checkboxLabelPlacement}
                                      labelOnchange={this.labelOnChange}
                                      id={o.optionId}
                                      boxType={
                                        parent.props.requiredMax === 1
                                          ? "radio"
                                          : "checkbox"
                                      }
                                      hideLabels={parent.data.hideCheckboxLabels}
                                      checkOnchange={this.handleChange}
                                      isSelected={this.getIsSelected(o.optionId)} />
                                  </div>
                                 
                                </Col>
                              </Row>
                            );
                          }}
                        />
                      </FormGroup>
                    )}</Media>
                </FormControl>
                <Row>
                  <Input
                    autoComplete="jirango-nofill"
                    style={{ display: "none" }}
                    valid={parent.isValid}
                    invalid={
                      (!parent.isValid && parent.props.errorMessage) ||
                      parent.forceValidationMessage
                    }
                  />
                  <FormFeedback valid={parent.isValid}>
                    {!parent.isValid
                      ? parent.data.validation.message
                      : /*    "" */
                      null}
                    {parent.forceValidationMessage ? this.forceValidate() : ""}
                  </FormFeedback>
                </Row>
                {cms.editMode &&
                  selectedElement &&
                  parent &&
                  selectedElement.contentId === parent.contentId ? (
                    <React.Fragment>
                      <OptionPopOver unblock={() => setTimeout(() => this.props.dispatch(cmsActions.blockDeselect(false)), 2000)}
                        block={() => this.props.dispatch(cmsActions.blockDeselect(true))}>
                        <SelectAddItem
                          onEdit={this.labelOnChange}
                          onAdd={this.addOption}
                          onDelete={this.removeOption}
                          onOrderChange={this.handleOrderChange}
                          onListAdd={this.addListOptions}
                          languageCode={form.languageCode}
                          options={options}
                        />
                      </OptionPopOver>
                    </React.Fragment>
                  ) : null}
              </React.Fragment>
            ) : null}

            {parent.data.displayType === "SELECT" ? (
              <React.Fragment>
                <div
                  className="responsive-input"
                  style={{ maxWidth: cms.editMode && previewDevice === 'smartphone' ? '100%' : (parent.data.style.width.toString().includes('%') ? parent.data.style.width : parent.data.style.width + '%'), width: cms.editMode && previewDevice === 'smartphone' ? '100%' : (parent.data.style.width.toString().includes('%') ? parent.data.style.width : parent.data.style.width + '%'), }}
                >
                  <Select
                    className="responsive-input"
                    onChange={selectedOption =>
                      this.handleChange(true, selectedOption.value)
                    }
                    onBlur={this.handleBlur}
                    isDisabled={parent.data.readOnly || false}
                    options={this.sortOptions().map((o, i) => {
                      return {
                        value: o.optionId,
                        label:
                          o.labels &&
                          o.labels.length > 0 &&
                          o.labels.find(l => {
                            return l.languageCode === form.languageCode;
                          }).text
                      };
                    })}
                    placeholder=""
                    styles={{
                      control: styles => ({
                        ...styles,
                        borderColor:
                          (template.template !== undefined &&
                            template.template.content.input.borderColor) ||
                          "unset",
                        borderRadius:
                          (template.template !== undefined &&
                            template.template.content.input.borderRadius) ||
                          "unset",
                        fontFamily:
                          (template.template !== undefined &&
                            template.template.content.input.fontFamily) ||
                          "unset",
                        fontWeight:
                          (template.template !== undefined &&
                            template.template.content.input.fontWeight) ||
                          "unset",
                        margin:
                          (template.template !== undefined &&
                            template.template.content.input.margin) ||
                          "unset",
                        boxShadow:
                          (template.template !== undefined &&
                            template.template.content.input.boxShadow) ||
                          "unset",
                        fontSize:
                          (template.template !== undefined &&
                            template.template.content.input.fontSize) ||
                          "unset",
                        color:
                          (template.template !== undefined &&
                            template.template.content.input.color) ||
                          "unset",
                        backgroundColor:
                          (template.template !== undefined &&
                            template.template.content.input.backgroundColor) ||
                          "unset",
                        maxWidth: "100%"
                      }),
                      menu: styles => ({
                        ...styles,
                        maxWidth: "100%"
                      }),
                      option: styles => ({
                        ...styles,
                        fontSize:
                          (template.template !== undefined &&
                            template.template.content.text.color) ||
                          "unset",
                        fontFamily:
                          (template.template !== undefined &&
                            template.template.content.text.fontFamily) ||
                          "unset"
                      }),
                      placeholder: styles => ({
                        ...styles,
                        fontSize:
                          (template.template !== undefined &&
                            template.template.content.text.color) ||
                          "unset",
                        fontFamily:
                          (template.template !== undefined &&
                            template.template.content.text.fontFamily) ||
                          "unset"
                      })
                    }}
                  />
                </div>

                <Row>
                  <Input
                    style={{ display: "none" }}
                    autoComplete="jirango-nofill"
                    valid={parent.isValid === true}
                    invalid={parent.isValid === false}
                  />
                  <FormFeedback valid={parent.isValid == true}>
                    {parent.isValid === false ? parent.data.validation.message : null}
                  </FormFeedback>
                </Row>

                {cms.editMode &&
                  selectedElement &&
                  parent &&
                  selectedElement.contentId === parent.contentId ? (
                    <React.Fragment>
                      <OptionPopOver unblock={() => setTimeout(() => this.props.dispatch(cmsActions.blockDeselect(false)), 2000)}
                        block={() => this.props.dispatch(cmsActions.blockDeselect(true))}>
                        <SelectAddItem
                          onEdit={this.labelOnChange}
                          onAdd={this.addOption}
                          onDelete={this.removeOption}
                          onOrderChange={this.handleOrderChange}
                          onListAdd={this.addListOptions}

                          languageCode={form.languageCode}
                          options={options}
                        />
                      </OptionPopOver>
                    </React.Fragment>
                  ) : null}
              </React.Fragment>
            ) : null}
          </React.Fragment>
        ) : null}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    selectedElement: state.form.selectedElement,
    previewDevice: state.template.previewDevice,
    language: state.language,
    template: state.template,
    form: state.form,
    cms: state.cms,
    attendee: state.attendee
  };
}

export default connect(mapStateToProps)(Options);

function OptionPopOver(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles(props);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    props.block();
  };

  const handleClose = () => {
    setAnchorEl(null);
    props.unblock();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <Button
        onClick={handleClick}
        type="button"
        style={{
          color: "#222",
          fontFamily: "unset",
          backgroundColor: "inherit",
          border: "none" 
        }}
      >
        <i className="fa fa-plus" />{" "}
        <SystemLabel name="AddOption" />
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        {props.children}
      </Popover>
    </div>
  );
}



